module.exports = __webpack_public_path__ + "static/media/69806caf-7c00-4742-8f54-584ad7d5ad6b.08ce0e67.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/69806caf-7c00-4742-8f54-584ad7d5ad6b.woff
// module id = 105
// module chunks = 0